import { FC, Fragment } from "react";

import { SmsOptInConfirmation } from "../../helpers/useSmsOptInConfirmation";
import { AuctionReminderCard } from "../../rows/AuctionReminderCard";
import { OutbidCard } from "../../rows/OutbidCard";
import { ThankYouBidPlacedCard } from "../../rows/ThankYouBidPlacedCard";
import { ThankYouNonWinnerCard } from "../../rows/ThankYouNonWinnerCard";
import { ThankYouWinnerCard } from "../../rows/ThankYouWinnerCard";
import { AutomatedCommunicationsFormData, RowKey } from "../../types";
import { buildFulfillmentRows } from "../shared/buildFulfillmentRows";

interface AuctionRowsProps {
  isSmsEnabled: boolean;
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  defaultValues: AutomatedCommunicationsFormData;
  smsOptIn: SmsOptInConfirmation;
  hasPickupEmail: boolean;
  hasShippingEmail: boolean;
}

export const AuctionRows: FC<AuctionRowsProps> = ({
  isSmsEnabled,
  openRow,
  onToggleOpen,
  defaultValues,
  smsOptIn,
  hasPickupEmail,
  hasShippingEmail,
}) => {
  const shared = { openRow, onToggleOpen };

  const rows: { key: RowKey; node: React.ReactNode }[] = [
    {
      key: "thank-you-bid-placed",
      node: (
        <ThankYouBidPlacedCard
          {...shared}
          isSmsEnabled={isSmsEnabled}
          defaultContent={defaultValues.thankYouBidPlaced.content}
        />
      ),
    },
    {
      key: "thank-you-email",
      node: (
        <ThankYouWinnerCard
          {...shared}
          isSmsEnabled={isSmsEnabled}
          defaultContent={defaultValues.thankYouWinner.content}
        />
      ),
    },
    {
      key: "thank-you-non-winner",
      node: (
        <ThankYouNonWinnerCard
          {...shared}
          isSmsEnabled={isSmsEnabled}
          defaultContent={defaultValues.thankYouNonWinner.content}
        />
      ),
    },
    {
      key: "outbid",
      node: <OutbidCard {...shared} isSmsEnabled={isSmsEnabled} smsOptIn={smsOptIn} />,
    },
    {
      key: "reminder-1",
      node: (
        <AuctionReminderCard
          num={1}
          {...shared}
          isSmsEnabled={isSmsEnabled}
          smsOptIn={smsOptIn}
          defaultContent={defaultValues.reminder1.content}
        />
      ),
    },
    {
      key: "reminder-2",
      node: (
        <AuctionReminderCard
          num={2}
          {...shared}
          isSmsEnabled={isSmsEnabled}
          smsOptIn={smsOptIn}
          defaultContent={defaultValues.reminder2.content}
        />
      ),
    },
    ...buildFulfillmentRows({ hasPickupEmail, hasShippingEmail, openRow, onToggleOpen, defaultValues }),
  ];

  return (
    <>
      {rows.map(({ key, node }) => (
        <Fragment key={key}>{node}</Fragment>
      ))}
    </>
  );
};
